import React from 'react';
import classNames from 'classnames';
import Bar from 'components/timeline_control/components/bar';
import { hash } from 'components/timeline_control/helpers';
import { connect } from 'react-redux';

class BarRow extends React.Component {
  render() {
    const { scale, pathParents } = this.props;
    const {
      timelineType,
      fromDateColumnName,
      toDateColumnName,
      viewOnly,
      thickBars,
      barColor,
      showProgress,
    } = this.props.timelineConfig;

    const rowClass = classNames({
      'bar-container': true,
      'chart-row': true,
      'last-row': this.props.lastRow,
    });

    const key = `InnerBar-${this.props.barHash}`;
    const bars = this.props.bars.map((bar, index) => {
      const barKey = `Bar-${this.props.barHash}-${hash(
        `${bar.label}${bar.from}${bar.to}${index}`
      )}`;

      // Build the unique path from the left to right to get to this
      // bar and then save this bars references using that key so
      // the dependency lines can find it.
      const pathId = `${pathParents.join('-')}-${bar.recordId}`;

      return (
        <Bar
          key={barKey}
          scale={scale}
          showProgress={Boolean(Number(showProgress))}
          bar={bar}
          barColor={bar.background || barColor}
          timelineType={timelineType}
          fromDateColumnName={fromDateColumnName}
          toDateColumnName={toDateColumnName}
          viewOnly={viewOnly}
          barHash={this.props.barHash}
          thickBars={thickBars}
          recordId={bar.recordId}
          recordType={bar.recordType}
          bookmarkId={bar.bookmarkId}
          recordEpicsEnabled={bar.recordEpicsEnabled}
          barRef={el => this.props.setBarReference(pathId, el)}
          fontSize={this.props.fontSize}
        />
      );
    });

    return (
      <div key={key} className={rowClass}>
        {bars}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const fontSize = state.getIn(['timelineConfig', 'fontSize']);

  return { fontSize };
};

export default connect(mapStateToProps)(BarRow);
